export default {
  budgetAllocationAndMediaMix: 'Asignación de Presupuesto y Mix de Medios',
  salesDecomposition: 'Descomposición de {kpi}',
  mediaEffect: 'Efecto de Medios',
  competitionEffect: 'Efecto de Competencia',
  economyAndOthersEffect: 'Efecto de Economía y Otros',
  pricingEffect: 'Efecto de Precios',
  distributionEffect: 'Efecto de Distribución',
  seasonalityAndOutliersEffect: 'Efecto de Estacionalidad y Outliers',
  spend: 'Inversión'
}
